import { useState } from 'react';
import { Modal } from '@mui/material';
import styles from './ImageViewModal.module.scss';
import { Loader } from 'src/components/Loader';
import CrossIcon from 'src/assets/images/icons/CloseIcon.svg';

export const ImageViewModal = ({ src, open, handleClose, Modalloader }) => {
	const [imageLoaded, setImageLoaded] = useState(false);
	const handleImageLoad = () => {
		setImageLoaded(true);
	};

	return (
		<>
			<Modal open={open} onClose={handleClose}>
				<div className={styles['image-container']}>
					{Modalloader && (
						<div className={styles['loader-div']}>
							<Loader />
						</div>
					)}
					{src && (
						<div className={styles['image-body']}>
							<img
								src={src}
								alt="part_image"
								className={styles.imageBlock}
								onLoad={handleImageLoad}
							/>
							{imageLoaded && (
								<img
									src={CrossIcon}
									alt="cross_icon"
									className={styles['cancel-btn']}
									onClick={() => handleClose()}
								/>
							)}
						</div>
					)}
				</div>
			</Modal>
		</>
	);
};
